// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-CompanyDetails-EditExpenseExportPopup___title--k25RT {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 32px;
  font-size: 20px;
  font-weight: 600;
  color: #1b2432;
}

.components-CompanyDetails-EditExpenseExportPopup___closeIcon--ynb1d {
  color: #1b2432;
}

.components-CompanyDetails-EditExpenseExportPopup___content--myBbI {
  padding: 0 32px 8px;
}

.components-CompanyDetails-EditExpenseExportPopup___actions--mB_Hj {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 32px 24px;
}

.components-CompanyDetails-EditExpenseExportPopup___dateField--b8hcF {
  display: flex;
  align-items: center;
  gap: 8px;
}

.components-CompanyDetails-EditExpenseExportPopup___toggleRow--axE1e {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
}

.components-CompanyDetails-EditExpenseExportPopup___toggleRow--axE1e label {
    text-align: right;
  }

.components-CompanyDetails-EditExpenseExportPopup___warningIcon--GOQMk {
  cursor: help;
}
`, "",{"version":3,"sources":["webpack://./components/CompanyDetails/EditExpenseExportPopup.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AAIjB;;AAHE;IACE,iBAAiB;EACnB;;AAIF;EACE,YAAY;AACd","sourcesContent":[".title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px 32px;\n  font-size: 20px;\n  font-weight: 600;\n  color: #1b2432;\n}\n\n.closeIcon {\n  color: #1b2432;\n}\n\n.content {\n  padding: 0 32px 8px;\n}\n\n.actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 32px 24px;\n}\n\n.dateField {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.toggleRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 8px;\n  label {\n    text-align: right;\n  }\n}\n\n\n.warningIcon {\n  cursor: help;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `components-CompanyDetails-EditExpenseExportPopup___title--k25RT`,
	"closeIcon": `components-CompanyDetails-EditExpenseExportPopup___closeIcon--ynb1d`,
	"content": `components-CompanyDetails-EditExpenseExportPopup___content--myBbI`,
	"actions": `components-CompanyDetails-EditExpenseExportPopup___actions--mB_Hj`,
	"dateField": `components-CompanyDetails-EditExpenseExportPopup___dateField--b8hcF`,
	"toggleRow": `components-CompanyDetails-EditExpenseExportPopup___toggleRow--axE1e`,
	"warningIcon": `components-CompanyDetails-EditExpenseExportPopup___warningIcon--GOQMk`
};
module.exports = ___CSS_LOADER_EXPORT___;
